<template>
  <div class="shop-view default-page">
    <empty-products-list v-if="products.length === 0" />
    <shop-navbar @openFilters="openFilters" @openSorting="openSorting" />
    <div class="shop-view__grid">
      <shop-product-tile
        v-for="product in products"
        :key="product.id"
        :product="product"
      />
    </div>
    <shop-filter-sheet-component />
    <shop-sorting-sheet-component />
  </div>
</template>

<script>
import { onMounted, computed } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import ShopNavbar from "@/components/shop/ShopNavbar.vue";
import EmptyProductsList from "@/components/shop/EmptyProductsList.vue";
import ShopProductTile from "@/components/shop/ShopProductTile.vue";
import ShopFilterSheetComponent from "@/components/sheets/ShopFilterSheetComponent.vue";
import ShopSortingSheetComponent from "@/components/sheets/ShopSortingSheetComponent.vue";
import { eventBus, events } from "@/eventBus";
import { shop as SHOP_CONFIG } from "@/config";
import ProductService from "@/services/ProductService";
import { mutationTypes } from "@/store";
import { mutationTypes as shopMutationTypes } from "@/store/modules/shop";

export default {
  name: "ShopView",
  components: {
    EmptyProductsList,
    ShopFilterSheetComponent,
    ShopSortingSheetComponent,
    ShopNavbar,
    ShopProductTile,
  },
  setup() {
    const store = useStore();
    const route = useRoute();
    const Product = new ProductService();

    const products = computed({
      get: () => store.getters["shop/filteredAndSortedProducts"],
      set: (payload) =>
        store.commit(`shop/${shopMutationTypes.SET_PRODUCTS}`, payload),
    });

    const setSpinner = (payload) =>
      store.commit(mutationTypes.SET_SPINNER, payload);
    const setCategories = (payload) =>
      store.commit(`shop/${shopMutationTypes.SET_CATEGORIES}`, payload);

    const openFilters = () => {
      eventBus.$emit(events.OPEN_SHEET_SHOP_FILTERS);
    };
    const openSorting = () => {
      eventBus.$emit(events.OPEN_SHEET_SHOP_SORTING);
    };

    const getData = async () => {
      setSpinner(true);
      try {
        const [productsRes, categoriesRes] = await Promise.all([
          Product.fetch(),
          Product.fetchCategories(),
        ]);

        if (
          productsRes.status === 200 &&
          categoriesRes.status === 200 &&
          productsRes.data &&
          categoriesRes.data
        ) {
          products.value = productsRes.data;
          setCategories(categoriesRes.data);
        }
      } catch (e) {
        console.error(
          "❌ Проблема з завантаженням продуктів або категорій:",
          e
        );
      } finally {
        setSpinner(false);
      }
    };

    const init = () => {
      getData();

      const query = route.query;

      const filterParams = {
        categories: query.categories
          ? query.categories.split(",").map(Number)
          : [],
        hasDiscount: query.hasDiscount === "1",
        priceFrom: query.priceFrom ? Number(query.priceFrom) : null,
        priceTo: query.priceTo ? Number(query.priceTo) : null,
      };

      const sortOption = query.sort || SHOP_CONFIG.SORT_OPTIONS.PRICE_ASC;

      store.commit("shop/SET_FILTER_PARAMS", filterParams);
      store.commit("shop/SET_SORT_OPTION", sortOption);
    };

    onMounted(() => {
      init();
    });

    return {
      products,
      openFilters,
      openSorting,
    };
  },
};
</script>

<style scoped lang="less">
@import "@/styles/_variables.less";
.shop-view {
  position: relative;

  &__grid {
    display: grid;
    gap: 20px;
    grid-template-columns: repeat(1, 1fr);

    @media (min-width: 320px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media @md {
      gap: 25px;
      grid-template-columns: repeat(3, 1fr);
    }

    @media @lg {
      gap: 30px;
      grid-template-columns: repeat(4, 1fr);
    }

    @media @xl {
      grid-template-columns: repeat(5, 1fr);
    }
  }
}
</style>
